// @flow
/* eslint-disable */
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isPostflopPositionAvailable } from '../../utils/postflopAvailability';
import useChallengeSession from '../../hooks/useChallengeSession';
import TrainerFeedback from '../../components/TrainerFeedback';
import SessionRecap from '../../components/TrainerFeedback/SessionRecap';
import feedbackStyles from '../../components/TrainerFeedback/styles.module.scss';
import useTrainerFeedback from '../../hooks/useTrainerFeedback';
import { isForcedPostflopStrategy, isForcedPostflopChallenge } from '../../utils/postflopPractice';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import ControlPanel from './ControlPanel';
import MobileSettings, { TRAINER_SETTINGS_MAX_WIDTH } from '../../components/MobileSettings';
import SessionStatistics from '../TrainingGame/ResultStatistics/SessionStatistics';
import { getPostflopStackOptions, getSupportedPostflopStack } from '../../utils/postflopStacks';
import ResultPanel from './ResultPanel';
import styles from './styles.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import actionTypes from '../../store/postflop/actionTypes';
import actionTypesGame from '../../store/game/actionTypes';
import cn from 'classnames';
import useWindowDimensions from '../../utils/windowDemensions';
import Card from '../../components/Card';
import PlayingCard from '../../components/PlayingCard';
import { Button } from 'components';
import Checkbox from '../../components/Checkbox';
import { sortCards } from '../../utils/game/sortRandomCards';
import CardChooser from './cardChooser';
import StepsHandler, {
  createPostflopActionHistoryEntry,
  formatPostflopAction,
  sortPostflopActions,
  getAvailablePostflopActions,
  getPostflopRoundState,
  filterLegalPostflopActions,
  hasInvalidPostflopStrategy,
  getInteractivePostflopActions,
  getPostflopActionBackground,
  getPostflopActionShortcut,
  getPostflopTableAmounts,
} from './stepsHandler';
import RangeGraph from './rangeGraph';
import PositionCircle from './positionCircle';
import {
  positionCirclesHandler,
  showAllSixMaxPositions,
} from './positionCirclesHandler';
import { potValueHandler } from './potValueHandler';
import boardOptions from './boardOptions';
import classnames from 'classnames';
import {
  filterPostflopHandTypeOptions,
  getPostflopBoardSuit,
  getPostflopMaxCards,
  shouldRequestPostflopSimilar,
  shouldUseNonSuitSelection,
  splitPostflopHand,
  stripHandToRanks,
} from '../../utils/postflopHand';
import normalizePostflopResultsPosition, {
  normalizePostflopGame,
  normalizePostflopRequestPosition,
} from '../../utils/postflopPosition';
import {
  getCompatibleResultsSelection,
  getHeadsUpResultsPositionOptions,
  getResultsBasePositionOptions,
  getDefaultResultsPreviousAction,
  getResultsPreviousActionOptions,
  getResultsPositionOptions,
  getResultsPositionTypeOptions as getChallengePositionTypeOptions,
  getResultsStepFromPosition,
  isResultsPositionAvailable,
  headsUpResultsPositionOptions,
  resultsPfrTypeOptions,
  resultsPlayerPositionOptions,
  resultsPositionOptions,
} from './resultsPositionOptions';

const tableSizeOptions = [
  { label: 'HU', value: 'HU' },
  { label: '6max', value: '6max' }
];

const positionTypeOptions = [
  { label: 'SRP', value: 'SRP' },
  { label: '3bet Pot', value: '3bP' },
  { label: '4bet Pot', value: '4bP' }
]

const boardSuitOptions = [
  { label: '2 Tone', value: 'two-tone' },
  { label: 'Rainbow', value: 'rainbow' },
  { label: 'Mono', value: 'mono' },
]

const boardTypeOptions = [
  { label: 'Unpaired', value: 'unpaired' },
  { label: 'Paired', value: 'paired' },
  { label: 'Straight', value: 'straight' },
]

const pageModeOptions = [
  { label: 'Study', value: 'Study' },
  { label: 'Train', value: 'Training' },
  { label: 'Challenge', textAdd: '(Saving Results)', value: 'Results' },
]

const highCardOptions = [
  { label: 'A', value: 'A' },
  { label: 'K', value: 'K' },
  { label: 'Q', value: 'Q' },
  { label: 'J', value: 'J' },
  { label: 'T', value: 'T' },
  { label: '9', value: '9' },
  { label: '8', value: '8' },
  { label: '7', value: '7' },
  { label: '6', value: '6' },
  { label: '5', value: '5' },
  { label: '4', value: '4' },
  { label: 'All', value: 'X' },
]

const handTypeOptions = [
  { label: 'Any', value: '' },
  { label: '1 PAIR', value: 'one_pair' },
  { label: '2 PAIRS', value: 'two_pair' },
  { label: 'TRIPS+', value: 'trips' },
  { label: 'STRAIGHT', value: 'straight' },
  { label: 'FLUSH', value: 'flush' },
  { label: 'SD', value: 'sd' },
  { label: 'FD', value: 'fd' },
  { label: 'BDFD', value: 'bdfd' },
]

const highLowOptions = [
  { label: 'High', value: 'High' },
  { label: 'Low', value: 'Low' }
]

const unavailablePlo5PositionValues = [
  'limpCheck',
  'limpRaiseCall',
  'UTGvsBTNvsBB',
  'BTNvsSBvsBB',
  'SBvsCOvsBTN',
  'BTNvsMPvsCO',
];

const huStudyPositionValues = {
  SRP: ['SBvsBB', 'limpCheck', 'limpRaiseCall'],
  '3bP': ['SBvsBB'],
  '4bP': ['SBvsBB'],
};

const huThreeBetPositionOption = { label: 'SB vs BB', value: 'SBvsBB' };

const twoHundredBbPositionValues = {
  SRP: [],
  '3bP': [
    'BTNvsUTG',
    'SBvsUTG',
    'BTNvsCO',
    'SBvsBTN',
    'BBvsSB',
  ],
  '4bP': [
    'BTNvsSB',
    'COvsBTN',
    'SBvsBB',
    'UTGvsBTN',
    'UTGvsSB',
  ],
};

const getStudyPositionTypeOptions = (
  selectedStack,
  selectedTable,
  selectedPlo5,
) => positionTypeOptions.filter((option) => {
  if (selectedStack === '50bb' && option.value === '4bP') return false;
  if (selectedPlo5 && selectedStack === '50bb' && option.value === '3bP') return false;
  if (selectedTable === 'HU' && selectedStack === '200bb' && option.value === 'SRP') return false;
  if (selectedTable === '6max' && selectedStack === '200bb') {
    return twoHundredBbPositionValues[option.value]?.length > 0;
  }
  return true;
});

const filterStudyPositionOptions = (
  options,
  selectedPositionType,
  selectedStack,
  selectedTable,
  selectedPlo5,
) => (selectedTable === 'HU' && selectedPositionType === '3bP'
  ? [huThreeBetPositionOption]
  : options.filter((option) => (
    (!selectedPlo5 || !unavailablePlo5PositionValues.includes(option.value))
    && isPostflopPositionAvailable(selectedPlo5, selectedTable, selectedStack, selectedPositionType, option.value)
    && (selectedTable !== 'HU'
      || huStudyPositionValues[selectedPositionType]?.includes(option.value))
    && !(selectedTable === '6max'
      && selectedStack === '200bb'
      && !twoHundredBbPositionValues[selectedPositionType]?.includes(option.value))
  )));

const isHuResultsPosition = (value = '') => [
  'BTNvsBB',
  'BBvsSB',
  'SBvsBB',
].includes(normalizePostflopResultsPosition(value));

const Postflop = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const tableSize = useSelector((state) => state.postflop.tableSize);
  const stackSize = useSelector((state) => state.postflop.stackSize);
  const positionType = useSelector((state) => state.postflop.positionType);
  const position = useSelector((state) => state.postflop.position);
  const positionOptions = useSelector((state) => state.postflop.positionOptions);
  const resultsPositionType = useSelector((state) => state.postflop.resultsPositionType);
  const resultsPfrType = useSelector((state) => state.postflop.resultsPfrType);
  const resultsPlayerPosition = useSelector((state) => state.postflop.resultsPlayerPosition);
  const resultsPosition = useSelector((state) => state.postflop.resultsPosition);
  const resultsPreviousAction = useSelector((state) => state.postflop.resultsPreviousAction);
  const boardSuit = useSelector((state) => state.postflop.boardSuit);
  const boardType = useSelector((state) => state.postflop.boardType);
  const selectedBoard = useSelector((state) => state.postflop.selectedBoard);
  const selectedCards = useSelector((state) => state.postflop.selectedCards);
  const boardSituation = useSelector((state) => state.postflop.boardSituation);
  const situationLoading = useSelector(state => state.api?.SET_POSTFLOP_SITUATION?.loading || false);
  const situationError = useSelector(state => state.api?.SET_POSTFLOP_SITUATION?.error || '');
  const comboError = useSelector(state => state.api?.GET_COMBO?.error || '');
  const searchValue = useSelector((state) => state.postflop.searchValue);
  const selectedHighCard = useSelector((state) => state.postflop.selectedHighCard);
  const selectedHandType = useSelector((state) => state.postflop.selectedHandType);
  const cardColor = useSelector((state) => state.game.cardColor);
  const heroColor = useSelector((state) => state.game.heroColor);
  const highLowOption = useSelector((state) => state.postflop.highLowOption);
  const pageMode = useSelector((state) => state.postflop.pageMode);
  const combo = useSelector((state) => state.postflop.combo);
  const nextCombo = useSelector((state) => state.postflop.nextCombo);
  const gameStarted = useSelector((state) => state.postflop.gameStarted);
  const nextComboLoading = useSelector((state) => (
    state.api?.GET_NEXT_COMBO?.loading || false
  ));
  const nextComboError = useSelector((state) => (
    state.api?.GET_NEXT_COMBO?.error || ''
  ));
  const [currentStep, setCurrentStep] = useState(['starting']);
  const [resultCategory, setResultCategory] = useState({label: 'All', value: 'all'})
  const [nonSuitCardSelected, setNonSuitCardSelected] = useState(false)
  const [currentActivePos, setCurrentActivePos] = useState('')
  const [actionHistory, setActionHistory] = useState([])
  const [isPlo5, setPlo5] = useState<boolean>(sessionStorage.getItem('isPlo5') === 'true');
  const challengeSession = useChallengeSession({
    url: isPlo5 ? '/5card/flop/challenge-results' : '/flop/challenge-results',
  });
  const [isAnswerCorrect, setIsAnswerCorrect] = useState<boolean>(false);
  const [newHandVisible, setNewHandVisible] = useState<boolean>(false);
  const [timerKey, setTimerKey] = useState<number>(1);
  const [trainingTimerEnabled, setTrainingTimerEnabled] = useState<boolean>(false);
  const [gameResults, setGameResults] = useState<Array<any>>([]);
  const [challengeStopRequested, setChallengeStopRequested] = useState<boolean>(false);
  const trainingRoundRef = useRef({ answered: true });
  const trainingRound = trainingRoundRef.current;
  const availableStackSizeOptions = getPostflopStackOptions(isPlo5, tableSize);
  const availablePositionTypeOptions = getStudyPositionTypeOptions(
    stackSize,
    tableSize,
    isPlo5,
  );
  const availableResultsPositionTypeOptions = getChallengePositionTypeOptions(
    stackSize,
    tableSize,
    isPlo5,
  );
  const activeResultsPositionOptions = tableSize === 'HU'
    ? headsUpResultsPositionOptions
    : resultsPositionOptions;
  const availablePositionOptions = filterStudyPositionOptions(
    positionOptions,
    positionType,
    stackSize,
    tableSize,
    isPlo5,
  );

  const { width, height } = useWindowDimensions();
  const isTrainingMode = pageMode.value === 'Training';
  const isResultsMode = pageMode.value === 'Results';
  const isInteractiveMode = isTrainingMode || isResultsMode;
  const feedback = useTrainerFeedback({ sessionKey: `${pageMode.value}:${isPlo5}` });
  // Register the deal before paint so cards do not flash, then remount for animation.
  useLayoutEffect(() => {
    if (gameStarted && combo?.combo) feedback.beginHand(combo);
  }, [gameStarted, combo, feedback.beginHand]);
  const canShowHighLow = !isInteractiveMode || (isTrainingMode && !gameStarted);
  const filterResultsOptionsForTable = (
    options = [],
    targetTableSize = tableSize,
    targetPositionType = resultsPositionType?.value,
  ) => options.filter(option => (
    (targetTableSize !== 'HU' || isHuResultsPosition(option.value))
    && isResultsPositionAvailable(isPlo5, targetTableSize, stackSize, targetPositionType, option.value, boardType)
  ));
  const getAvailableResultsPositionOptions = (
    targetPositionType,
    targetPfrType,
    targetPlayerPosition,
    targetTableSize = tableSize,
  ) => filterResultsOptionsForTable(
    targetTableSize === 'HU'
      ? getHeadsUpResultsPositionOptions(
        targetPositionType,
        targetPfrType,
        targetPlayerPosition,
      )
      : getResultsPositionOptions(
        targetPositionType,
        targetPfrType,
        targetPlayerPosition,
      ),
    targetTableSize,
    targetPositionType,
  );
  const resolveResultsSelection = (
    targetPositionType,
    targetPfrType,
    targetPlayerPosition,
    targetTableSize = tableSize,
    targetStackSize = stackSize,
    targetBoardType = boardType,
  ) => getCompatibleResultsSelection(
    targetPositionType,
    targetPfrType,
    targetPlayerPosition,
    (option, resolvedPositionType) => isResultsPositionAvailable(
      isPlo5, targetTableSize, targetStackSize, resolvedPositionType, option.value, targetBoardType,
    ),
    getChallengePositionTypeOptions(
      targetStackSize,
      targetTableSize,
      isPlo5,
    ),
    targetTableSize === 'HU'
      ? headsUpResultsPositionOptions
      : resultsPositionOptions,
  );
  const currentResultsPositionOptions = getAvailableResultsPositionOptions(
    resultsPositionType?.value,
    resultsPfrType?.value,
    resultsPlayerPosition?.value,
  );
  const currentResultsBasePositionOptions = filterResultsOptionsForTable(getResultsBasePositionOptions(
    resultsPositionType?.value,
    resultsPfrType?.value,
    resultsPlayerPosition?.value,
    activeResultsPositionOptions,
  ));
  const currentResultsPreviousActionOptions = filterResultsOptionsForTable(getResultsPreviousActionOptions(
    resultsPositionType?.value,
    resultsPfrType?.value,
    resultsPlayerPosition?.value,
    resultsPosition?.value?.split('_')[0],
    activeResultsPositionOptions,
  ));
  const currentResultsPfrTypeOptions = resultsPfrTypeOptions.filter((pfrOption) => (
    resultsPlayerPositionOptions.some((playerOption) => (
      getAvailableResultsPositionOptions(
        resultsPositionType?.value,
        pfrOption.value,
        playerOption.value,
      ).length > 0
    ))
  ));
  const currentResultsPlayerPositionOptions = resultsPlayerPositionOptions.filter(
    (playerOption) => getAvailableResultsPositionOptions(
      resultsPositionType?.value,
      resultsPfrType?.value,
      playerOption.value,
    ).length > 0,
  );
  const tablePositionType = isResultsMode ? resultsPositionType?.value : positionType;
  const tablePosition = tableSize === 'HU'
    ? 'SBvsBB'
    : (isResultsMode
      ? normalizePostflopRequestPosition(
        resultsPositionType?.value,
        resultsPosition?.value,
        tableSize,
      )
      : position[0]);
  const visualTablePosition = tableSize === 'HU' ? 'HU_SBvsBB' : tablePosition;
  const initialPot = potValueHandler(tablePositionType, visualTablePosition);
  const logicalPositionCircles = positionCirclesHandler(tablePositionType, visualTablePosition);
  const visualPositionCircles = tableSize === '6max'
    ? showAllSixMaxPositions(logicalPositionCircles)
    : logicalPositionCircles;
  const selectedStackSize = Number(String(stackSize).replace('bb', ''));
  const stackByPosition = logicalPositionCircles.reduce((stacks, circle) => {
    if (!circle.show || !circle.label) return stacks;

    return {
      ...stacks,
      [circle.label]: Math.max(
        0,
        circle.initialCircleValue + selectedStackSize - 100,
      ),
    };
  }, {});
  const getPostflopActionContext = (step = currentStep, history = actionHistory) => ({
    tableSize,
    stackSize,
    positionType: tablePositionType,
    position: tablePosition,
    boardType,
    boardSuit: isResultsMode ? getPostflopBoardSuit(combo?.board || selectedBoard, boardSuit) : boardSuit,
    isPlo5,
    currentStep: step,
    actionHistory: history,
    stackByPosition,
    initialPot,
    positionLabels: logicalPositionCircles
      .filter((circle) => circle.show)
      .map((circle) => circle.label),
    pfrIsOop: isResultsMode
      ? resultsPfrType?.value === 'pfr_oop'
      : undefined,
  });

  const getActivePositionLabel = (step = ['starting'], circles = []) => {
    const currentLabels = circles.filter((el) => el.show).map((el) => el.label);

    if (!currentLabels.length) return '';

    if (step[0] === 'starting') {
      return currentLabels[0];
    }

    if (step.length === 1) {
      return currentLabels[1] || currentLabels[0];
    }

    return currentLabels[step.length % currentLabels.length] || currentLabels[0];
  };

  const availableTrainingActions = getAvailablePostflopActions(
    boardSituation,
    currentStep,
    false,
    !isInteractiveMode,
    getPostflopActionContext(),
  );
  const availableHandTypeOptions = isTrainingMode && selectedBoard
    ? filterPostflopHandTypeOptions(handTypeOptions, selectedBoard)
    : isResultsMode
    ? handTypeOptions.filter(option => (
      (option.value !== 'flush' || boardType !== 'paired')
      && (option.value !== 'straight' || boardType === 'straight')
      && isResultsPositionAvailable(isPlo5, tableSize, stackSize, resultsPositionType?.value, resultsPosition?.value, boardType, option.value)
    ))
    : handTypeOptions;
  const correctAnswerContext = getPostflopActionContext(
    currentStep,
    actionHistory.filter(entry => !entry.interactive),
  );
  const correctAnswerLabels = newHandVisible && !isAnswerCorrect && Array.isArray(combo?.answer)
    ? [...new Set(sortPostflopActions(
      combo.answer.filter(action => typeof action === 'string' && action),
      correctAnswerContext,
    ).map(action => formatPostflopAction(action, correctAnswerContext)))]
    : [];
  const canShowInteractiveStage = isTrainingMode ? !!selectedBoard : isResultsMode;
  const storedAnswerActions = isInteractiveMode && combo?.combo
    ? getInteractivePostflopActions(
      combo,
      currentStep,
      availableTrainingActions,
      true,
    )
    : availableTrainingActions;
  const currentStrategy = boardSituation.find(item => item.previous_actions === currentStep.join('-')) || {};
  const invalidStrategy = hasInvalidPostflopStrategy(currentStrategy, getPostflopActionContext())
    || (isInteractiveMode && combo?.combo && hasInvalidPostflopStrategy(combo, getPostflopActionContext()));
  const resultAnswerActions = invalidStrategy ? [] : filterLegalPostflopActions(storedAnswerActions, getPostflopActionContext());
  const canStartTrainingTimer = !invalidStrategy && !newHandVisible && !challengeStopRequested
    && gameStarted
    && combo?.combo
    && (isResultsMode || trainingTimerEnabled)
    && (isResultsMode ? resultAnswerActions.length > 0 : boardSituation.length > 0);
  const roundState = getPostflopRoundState(getPostflopActionContext());
  const hasPlayableTrainingStrategy = !!selectedBoard && boardSituation.length > 0
    && !!currentStrategy.previous_actions && !invalidStrategy && !roundState?.complete
    && !situationLoading && !situationError;
  const forcedPracticeDecision = isResultsMode
    ? isForcedPostflopChallenge({
      tableSize, stackSize, positionType: tablePositionType, currentStep,
      boardType, handType: selectedHandType?.value, isPlo5,
    })
    : isForcedPostflopStrategy(currentStrategy);
  const canStartGame = !forcedPracticeDecision && (isResultsMode
    ? !challengeStopRequested && !challengeSession.saving && !challengeSession.error
    : hasPlayableTrainingStrategy);
  const activePositionLabel = roundState
    ? roundState.actingPosition : getActivePositionLabel(currentStep, logicalPositionCircles);

  const getVisualSeatIndex = (idx, label) => {
    if (tableSize === 'HU') {
      if (isInteractiveMode && activePositionLabel) {
        return label === activePositionLabel ? 0 : 3;
      }
      if (label === 'SB') return 0;
      if (label === 'BB') return 3;
    }

    if (!isInteractiveMode || !gameStarted || !activePositionLabel) {
      return idx;
    }

    const activeIndex = logicalPositionCircles.findIndex((circle) => (
      circle.show && circle.label === activePositionLabel
    ));
    const bottomSeatIndex = 0;

    if (activeIndex < 0 || activeIndex === bottomSeatIndex) {
      return idx;
    }

    return (idx - activeIndex + logicalPositionCircles.length)
      % logicalPositionCircles.length;
  };

  const resetLocalPostflopState = ({ resetFeedback = true } = {}) => {
    if (resetFeedback) feedback.resetSession();
    trainingRoundRef.current = { answered: true };
    setCurrentStep(['starting']);
    setResultCategory({ label: 'All', value: 'all' });
    setNonSuitCardSelected(false);
    setCurrentActivePos('');
    setActionHistory([]);
    setIsAnswerCorrect(false);
    setNewHandVisible(false);
    setTimerKey((value) => value + 1);
    setGameResults([]);
    setChallengeStopRequested(false);
  };

  const resetLocalSelectionState = () => {
    trainingRoundRef.current = { answered: true };
    setCurrentStep(['starting']);
    setResultCategory({ label: 'All', value: 'all' });
    setNonSuitCardSelected(false);
    setCurrentActivePos('');
    setActionHistory([]);
    setIsAnswerCorrect(false);
    setNewHandVisible(false);
    setTimerKey((value) => value + 1);
    setChallengeStopRequested(false);
  };

  const getResultData = (arr) => {
    let right = 0;
    let wrong = 0;

    for (let i = 0; i < arr.length; i += 1) {
      if (arr[i].correct) {
        right += 1;
      } else {
        wrong += 1;
      }
    }

    return {
      right,
      wrong,
      all: right + wrong,
    };
  };

  useEffect(() => {
    dispatch({ type: actionTypes.SET_DEFAULT });
    dispatch({ type: actionTypesGame.GET_CARD_COLOR });
    dispatch({ type: actionTypesGame.GET_HERO_COLOR });

    return () => {
      trainingRoundRef.current = { answered: true };
      dispatch({ type: actionTypes.SET_DEFAULT });
    };
  }, [])

  useEffect(() => {
    function checkPlo5() {
      const item = sessionStorage.getItem('isPlo5');
      setPlo5(item === 'true');
    }

    window.addEventListener('storage', checkPlo5);

    return () => {
      window.removeEventListener('storage', checkPlo5);
    };
  }, []);

  useEffect(() => {
    if (challengeSession.active) {
      trainingRoundRef.current.answered = true;
      setChallengeStopRequested(true);
      challengeSession.stop().then(() => setChallengeStopRequested(false)).catch(() => {});
    }
    dispatch({ type: actionTypes.SET_DEFAULT });
  }, [isPlo5]);

  const makeSituationRequest = () => {
    dispatch({ type: actionTypes.SET_POSTFLOP_SITUATION, payload: { isPlo5 } })
  }

  const shouldUseClientChallengeBoard = () => (
    tableSize === 'HU'
    || resultsPositionType?.value === '4bP'
    || (isPlo5
      && tableSize === '6max'
      && stackSize === '100bb'
      && resultsPositionType?.value === '3bP'
      && normalizePostflopRequestPosition(
        resultsPositionType?.value,
        resultsPosition?.value,
        tableSize,
      ) === 'SBvsUTG')
  )

  const makeComboRequest = () => {
    trainingRoundRef.current = { answered: false };
    dispatch({ type: `${actionTypes.SET_SIMILAR_RESPONSE}_SUCCESS`, payload: { data: null, currentCards: [] } })
    dispatch({ type: `${actionTypes.SET_COMBO}_SUCCESS`, payload: '' })
    dispatch({ type: actionTypes.CLEAR_NEXT_COMBO })
    dispatch({ type: `${actionTypes.GET_NEXT_COMBO}_RESET` })
    if (isResultsMode) {
      dispatch({ type: `${actionTypes.SET_BOARD_SITUATION}_SUCCESS`, payload: [] })
    }
    setTimerKey((value) => value + 1)
    const needsChallengeBoard = isResultsMode && shouldUseClientChallengeBoard();
    dispatch({
      type: actionTypes.GET_COMBO,
      payload: {
        currentStep,
        isPlo5,
        board: needsChallengeBoard ? getRandomChallengeBoard() : '',
      },
    })
  }

  const prefetchNextChallengeCombo = () => {
    const needsChallengeBoard = shouldUseClientChallengeBoard();
    dispatch({
      type: actionTypes.GET_NEXT_COMBO,
      payload: {
        currentStep,
        isPlo5,
        board: needsChallengeBoard ? getRandomChallengeBoard() : '',
      },
    });
  };

  const setHighLowOption = (e) => {
    dispatch({ type: actionTypes.SET_HIGH_LOW, payload: { value: e.value, label: e.label } })
  }

  const setPageMode = (e) => {
    resetLocalPostflopState();
    dispatch({ type: actionTypes.SET_PAGE_MODE, payload: { value: e.value, label: e.label } })
    if (e.value === 'Results') {
      const selection = resolveResultsSelection(
        resultsPositionType,
        resultsPfrType,
        resultsPlayerPosition,
        tableSize,
        stackSize,
      );
      if (selection) applyResultsSelection(selection);
    }
  }

  const setGameStarted = async (e) => {
    if (e && !canStartGame) return;
    if (e && !isResultsMode && (situationLoading || situationError || !boardSituation.length || !currentStrategy.previous_actions || invalidStrategy || roundState?.complete)) return;
    if (e && isResultsMode) {
      challengeSession.start();
      setChallengeStopRequested(false);
    }
    if (!e) {
      trainingRoundRef.current.answered = true;
      if (isResultsMode || challengeSession.active) {
        setChallengeStopRequested(true);
        try {
          await challengeSession.stop();
        } catch (error) {
          // Keep the hand and session until the exact failed save is retried.
          return;
        }
      }
      trainingRoundRef.current = { answered: true };
    }
    dispatch({ type: actionTypes.SET_GAME_STARTED, payload: e })
    if (e === true) {
      feedback.resetSession();
      feedback.prepareAudio();
      setGameResults([])
      setResultCategory({ label: 'All', value: 'all' })
      setNonSuitCardSelected(false)
      setIsAnswerCorrect(false)
      setNewHandVisible(false)
      dispatch({ type: actionTypes.SET_SEARCH_VALUE, payload: '' })
      makeComboRequest();
      return;
    }
    feedback.finishSession();
    resetLocalPostflopState({ resetFeedback: false });
    setCurrentStep(isResultsMode
      ? getResultsStepFromPosition(resultsPosition?.value, resultsPfrType?.value)
      : ['starting'])
    dispatch({ type: `${actionTypes.SET_COMBO}_SUCCESS`, payload: '' })
    dispatch({ type: actionTypes.SET_SELECTED_CARDS, payload: [] })
    dispatch({ type: actionTypes.SET_SEARCH_VALUE, payload: '' })
    dispatch({ type: `${actionTypes.SET_POSTFLOP_SIMILAR}_RESET` })
    if (isResultsMode) {
      dispatch({ type: actionTypes.SET_SELECTED_BOARD, payload: { value: '' } })
    }
  }

  const makeSimilarRequest = (step, cards, fromSearch = false) => {
    if (!shouldRequestPostflopSimilar(cards, isPlo5)) {
      dispatch({ type: `${actionTypes.SET_SIMILAR_RESPONSE}_SUCCESS`, payload: { data: null } })
      return
    }
    dispatch({
      type: actionTypes.SET_POSTFLOP_SIMILAR,
      payload: {
        currentStep: step,
        cards,
        fromSearch,
        isPlo5,
      },
    })
  }

  const handleCardClick = () => {
    dispatch({ type: actionTypesGame.UPDATE_CARD_COLOR })
  }

  const handleHeroCardClick = () => {
    dispatch({ type: actionTypesGame.UPDATE_HERO_COLOR })
  }

  const addActionToHistory = (action, pos, interactive = false) => {
    setActionHistory((history) => {
      const latestAction = history[history.length - 1]
      const pot = latestAction?.values?.pot
        ?? initialPot
      const entry = createPostflopActionHistoryEntry(
        pot,
        action,
        pos,
        getPostflopActionContext(currentStep, history),
      )

      return history.concat(interactive ? { ...entry, interactive: true } : entry)
    })
  }

  const handleSetCurrentStep = (e, isBack = false) => {
    setCurrentStep(e)

    if (isBack) {
      setActionHistory((history) => history.slice(0, -1))
    } else {
      addActionToHistory(e[e.length - 1], activePositionLabel || currentActivePos)
    }

    if (pageMode.value === 'Study') {
      setSearchValue(selectedCards.join(''))
      makeSimilarRequest(e, selectedCards.join(''));
    }
  }

  const setTableSize = (e) => {
    resetLocalSelectionState();
    dispatch({ type: actionTypes.SET_TABLE_SIZE, payload: e });

    if (isResultsMode) {
      const nextStack = getSupportedPostflopStack(stackSize, isPlo5, e.value);
      if (nextStack.value !== stackSize) {
        dispatch({ type: actionTypes.SET_STACK_SIZE, payload: nextStack });
      }
      applyResultsSelection(resolveResultsSelection(
        resultsPositionType,
        resultsPfrType,
        resultsPlayerPosition,
        e.value,
        nextStack.value,
      ), e.value);
      return;
    }

    if (e.value === 'HU') {
      const nextPositionTypes = getStudyPositionTypeOptions(
        stackSize,
        e.value,
        isPlo5,
      );
      const nextPositionType = nextPositionTypes.find(
        (option) => option.value === positionType,
      ) || nextPositionTypes[0];
      if (nextPositionType?.value !== positionType) {
        dispatch({ type: actionTypes.SET_POSITION_TYPE, payload: nextPositionType });
      }
      dispatch({
        type: actionTypes.SET_POSITION,
        payload: { label: 'SB vs BB', value: 'SBvsBB' },
      });
    }
  };

  const setSelectedHighCard = (e) => {
    resetLocalSelectionState();
    dispatch({ type: actionTypes.SET_SELECTED_HIGH_CARD, payload: e });
  };

  const setSelectedHandType = (e) => {
    resetLocalSelectionState();
    dispatch({ type: actionTypes.SET_SELECTED_HAND_TYPE, payload: e });
  };

  useEffect(() => {
    if (!isInteractiveMode || !selectedHandType?.value) return;

    const selectedTypeIsAvailable = availableHandTypeOptions.some(
      (option) => option.value === selectedHandType.value,
    );

    if (!selectedTypeIsAvailable) {
      setSelectedHandType(handTypeOptions[0]);
    }
  }, [isTrainingMode, isResultsMode, selectedBoard, boardType, selectedHandType?.value, tableSize, stackSize, resultsPositionType?.value, resultsPosition?.value]);

  const setStackSize = (e) => {
    resetLocalSelectionState();
    dispatch({ type: actionTypes.SET_STACK_SIZE, payload: e });

    if (isResultsMode) {
      const selection = resolveResultsSelection(
        resultsPositionType,
        resultsPfrType,
        resultsPlayerPosition,
        tableSize,
        e.value,
      );
      if (selection) applyResultsSelection(selection);
      return;
    }

    const nextPositionTypes = getStudyPositionTypeOptions(
      e.value,
      tableSize,
      isPlo5,
    );
    const nextPositionType = nextPositionTypes.find(
      (option) => option.value === positionType,
    ) || nextPositionTypes[0];
    const currentOptions = nextPositionType?.value === positionType
      ? positionOptions
      : [];

    if (nextPositionType?.value !== positionType) {
      dispatch({ type: actionTypes.SET_POSITION_TYPE, payload: nextPositionType });
      return;
    }

    const nextPositions = filterStudyPositionOptions(
      currentOptions,
      nextPositionType?.value,
      e.value,
      tableSize,
      isPlo5,
    );
    if (!nextPositions.some((option) => option.value === position[0]) && nextPositions[0]) {
      dispatch({ type: actionTypes.SET_POSITION, payload: nextPositions[0] });
    }
  };

  useEffect(() => {
    const supportedStack = getSupportedPostflopStack(stackSize, isPlo5, tableSize);
    if (supportedStack.value !== stackSize) setStackSize(supportedStack);
  }, [isPlo5, tableSize, stackSize]);

  useEffect(() => {
    if (isResultsMode || availablePositionOptions.some(option => option.value === position[0])) return;
    if (availablePositionOptions[0]) setPosition(availablePositionOptions[0]);
  }, [isPlo5, tableSize, stackSize, positionType, position[0], isResultsMode]);

  const setPositionType = (e) => {
    resetLocalSelectionState();
    if (pageMode.value === 'Study') {
      setNonSuitCardSelected(false);
      dispatch({ type: actionTypes.SET_SELECTED_CARDS, payload: [] });
      dispatch({ type: actionTypes.SET_SEARCH_VALUE, payload: '' });
      dispatch({
        type: `${actionTypes.SET_SIMILAR_RESPONSE}_SUCCESS`,
        payload: { data: null },
      });
    }
    dispatch({ type: actionTypes.SET_POSITION_TYPE, payload: e });
    if (tableSize === 'HU') {
      dispatch({
        type: actionTypes.SET_POSITION,
        payload: { label: 'SB vs BB', value: 'SBvsBB' },
      });
    }
  };

  const setPosition = (e) => {
    resetLocalSelectionState();
    if (pageMode.value === 'Study') {
      setNonSuitCardSelected(false);
      dispatch({ type: actionTypes.SET_SELECTED_CARDS, payload: [] });
      dispatch({ type: actionTypes.SET_SEARCH_VALUE, payload: '' });
      dispatch({
        type: `${actionTypes.SET_SIMILAR_RESPONSE}_SUCCESS`,
        payload: { data: null },
      });
    }
    dispatch({ type: actionTypes.SET_POSITION, payload: e });
  };

  const syncResultsStep = (value = '', selectedPfrType = resultsPfrType?.value) => {
    resetLocalSelectionState();
    setCurrentStep(getResultsStepFromPosition(value, selectedPfrType));
  };

  const applyResultsSelection = (selection, targetTableSize = tableSize) => {
    if (!selection) return;

    const defaultPreviousAction = getDefaultResultsPreviousAction(
      selection.positionType.value,
      selection.pfrType.value,
      selection.playerPosition.value,
      selection.position.value.split('_')[0],
      targetTableSize === 'HU'
        ? headsUpResultsPositionOptions
        : resultsPositionOptions,
    );

    dispatch({ type: actionTypes.SET_RESULTS_POSITION_TYPE, payload: selection.positionType });
    dispatch({ type: actionTypes.SET_RESULTS_PFR_TYPE, payload: selection.pfrType });
    dispatch({ type: actionTypes.SET_RESULTS_PLAYER_POSITION, payload: selection.playerPosition });
    dispatch({ type: actionTypes.SET_RESULTS_POSITION, payload: selection.position });
    dispatch({ type: actionTypes.SET_RESULTS_PREVIOUS_ACTION, payload: defaultPreviousAction });
    syncResultsStep(selection.position.value, selection.pfrType.value);
  };

  const setResultsPositionType = (e) => {
    applyResultsSelection(resolveResultsSelection(
      e,
      resultsPfrType,
      resultsPlayerPosition,
    ));
  };

  const setResultsPfrType = (e) => {
    applyResultsSelection(resolveResultsSelection(
      resultsPositionType,
      e,
      resultsPlayerPosition,
    ));
  };

  const setResultsPlayerPosition = (e) => {
    applyResultsSelection(resolveResultsSelection(
      resultsPositionType,
      resultsPfrType,
      e,
    ));
  };

  const setResultsPosition = (e) => {
    const nextPreviousActionOptions = filterResultsOptionsForTable(getResultsPreviousActionOptions(
      resultsPositionType.value,
      resultsPfrType.value,
      resultsPlayerPosition.value,
      e.value,
      activeResultsPositionOptions,
    ));
    const nextPreviousAction = nextPreviousActionOptions[0] || null;
    const nextPosition = currentResultsPositionOptions
      .find((item) => item.value === nextPreviousAction?.value) || nextPreviousAction || e;

    dispatch({ type: actionTypes.SET_RESULTS_POSITION, payload: nextPosition });
    dispatch({ type: actionTypes.SET_RESULTS_PREVIOUS_ACTION, payload: nextPreviousAction });
    syncResultsStep(nextPosition?.value);
  };

  const setResultsPreviousAction = (e) => {
    const nextPosition = currentResultsPositionOptions.find((item) => item.value === e.value) || e;

    dispatch({ type: actionTypes.SET_RESULTS_POSITION, payload: nextPosition });
    dispatch({ type: actionTypes.SET_RESULTS_PREVIOUS_ACTION, payload: e });
    syncResultsStep(nextPosition?.value);
  };

  const setBoardType = (e) => {
    resetLocalSelectionState();
    dispatch({ type: actionTypes.SET_BOARD_TYPE, payload: e });
    if (isResultsMode && !isResultsPositionAvailable(
      isPlo5, tableSize, stackSize, resultsPositionType?.value, resultsPosition?.value, e.value,
    )) {
      applyResultsSelection(resolveResultsSelection(
        resultsPositionType, resultsPfrType, resultsPlayerPosition, tableSize, stackSize, e.value,
      ));
    }
  };

  const setBoardSuit = (e) => {
    resetLocalSelectionState();
    dispatch({ type: actionTypes.SET_BOARD_SUIT, payload: e });
  };

  const setSelectedBoard = (e) => {
    setCurrentStep(['starting'])
    setActionHistory([])
    setNonSuitCardSelected(false)
    dispatch({ type: actionTypes.SET_SELECTED_BOARD, payload: e})
    dispatch({ type: actionTypes.SET_SELECTED_CARDS, payload: []})
    makeSituationRequest();
  }

  // Keep the Challenge board, positions and dealt hand in the same visible frame.
  useLayoutEffect(() => {
    if (!isResultsMode || !combo?.board) return;

    const nextStep = combo?.previous_actions
      ? combo.previous_actions.split('-')
      : currentStep;
    const previousActions = nextStep.filter((action) => action !== 'starting')
    let pot = initialPot
    const previousActionHistory = [];
    previousActions.forEach((action, index) => {
      const positionStep = index === 0
        ? ['starting']
        : previousActions.slice(0, index)
      const pos = getPostflopRoundState(getPostflopActionContext(positionStep, previousActionHistory))?.actingPosition
        || getActivePositionLabel(positionStep, logicalPositionCircles)
      const entry = createPostflopActionHistoryEntry(
        pot,
        action,
        pos,
        getPostflopActionContext(positionStep, previousActionHistory),
      )

      pot = entry.values.pot
      previousActionHistory.push(entry)
    })

    dispatch({ type: actionTypes.SET_SELECTED_BOARD, payload: { value: combo.board } });
    // Loading the Challenge board clears the previous hand filter. Restore the dealt hand.
    dispatch({ type: actionTypes.SET_SEARCH_VALUE, payload: stripHandToRanks(combo.combo) });
    dispatch({
      type: actionTypes.SET_POSTFLOP_SITUATION,
      payload: { board: combo.board, isPlo5 },
    });
    setCurrentStep(nextStep);
    setActionHistory(previousActionHistory);
    setCurrentActivePos('');
  }, [combo?.board, combo?.combo, combo?.previous_actions, isResultsMode]);

  const setSearchValue = (e) => {
    const payload = e.replaceAll('x', '')
    dispatch({ type: actionTypes.SET_SEARCH_VALUE, payload: payload })
  }

  const syncCardsFromSearch = (value) => {
    const nextCards = splitPostflopHand(value).slice(0, getPostflopMaxCards(isPlo5));

    setNonSuitCardSelected(shouldUseNonSuitSelection(nextCards));
    dispatch({ type: actionTypes.SET_SELECTED_CARDS, payload: nextCards });
    dispatch({
      type: `${actionTypes.SET_SIMILAR_RESPONSE}_SUCCESS`,
      payload: { data: null },
    });
  };

  const setSelectedCards = (e, removeAction = false, removeIndex = -1) => {
    if (removeAction) {
      const newSelectedCards = removeIndex >= 0
        ? selectedCards.filter((_, index) => index !== removeIndex)
        : selectedCards.slice(0, -1)
      if (newSelectedCards.length === 0) {
        setNonSuitCardSelected(false)
        dispatch({ type: `${actionTypes.SET_SIMILAR_RESPONSE}_SUCCESS`, payload: { data: null } })
      } else {
        setNonSuitCardSelected(shouldUseNonSuitSelection(newSelectedCards))
      }
      setSearchValue(newSelectedCards.join(''))
      if (newSelectedCards.length > 0) {
        makeSimilarRequest(currentStep, newSelectedCards.join(''));
      }
      return dispatch({ type: actionTypes.SET_SELECTED_CARDS, payload: newSelectedCards })
    }

    if (selectedCards.length < getPostflopMaxCards(isPlo5)) {
      const newSelectedCards = selectedCards.concat(e)

      setNonSuitCardSelected(shouldUseNonSuitSelection(newSelectedCards))
      dispatch({ type: actionTypes.SET_SELECTED_CARDS, payload: newSelectedCards })
      setSearchValue(newSelectedCards.join(''))
      makeSimilarRequest(currentStep, newSelectedCards.join(''));

      if (newSelectedCards.length === getPostflopMaxCards(isPlo5)) {
        setResultCategory({label: 'All', value: 'all'})
      }
    }
  }

  const clearCards = () => {
    setNonSuitCardSelected(false)
    setSearchValue('')
    dispatch({ type: actionTypes.SET_SELECTED_CARDS, payload: [] })
    dispatch({ type: `${actionTypes.SET_SIMILAR_RESPONSE}_SUCCESS`, payload: { data: null } })
  }

  const isPositionActive = (show, label) => {
    if (!show) return false
    return label === activePositionLabel
  }

  const circleValueHandler = (value) => {
    if (stackSize === '100bb') return value
    if (stackSize === '50bb') return value - 50
    return value + 100
  }

  const filterByHighCard = (arr) => {
    return arr.filter(el => selectedHighCard ? el.label.at(0) === selectedHighCard : el)
  }

  const filterByBoardType = (arr) => {
    return arr.filter(el => el.boardType === boardType)
  }

  const isUnavailableBoardVariant = (value) => (
    tableSize === '6max'
    && stackSize === '200bb'
    && positionType === '3bP'
    && position[0] === 'SBvsBTN'
    && value === 'Ks9h5h'
  )

  const hasHighAndLow = (selectedValue) => {
    const one = selectedValue.at(0)
    const three = selectedValue.at(2)
    const five = selectedValue.at(4)
    const label = one + three + five

    const suitedResult = boardOptions.filter(el => el.boardSuit === boardSuit)
    const boardTypedResult = filterByBoardType(suitedResult)

    const target = boardTypedResult.find(item => item.label === label);
    if (!target) return false;
    return target.hasHighLow
  };

  const shouldShowHighLow = () => {
    if (boardSuit === 'mono') return false
    if (!hasHighAndLow(selectedBoard)) return false

    const label = selectedBoard.at(0) + selectedBoard.at(2) + selectedBoard.at(4)
    const target = filterByBoardType(
      boardOptions.filter(el => el.boardSuit === boardSuit)
    ).find(item => item.label === label)

    return target.varieties.every(item => (
      !isUnavailableBoardVariant(item.slice(0, -2))
    ))
  }

  const sliceHighLow = (el) => {
    if (el.hasHighLow) {
      const first = el.varieties[0]
      const second = el.varieties[1]
      const firstIsHigh = first.at(-1) === 'H'
      if (highLowOption.value === 'High') {
        return firstIsHigh ? first.slice(0, -2) : second.slice(0, -2)
      } else {
        return firstIsHigh ? second.slice(0, -2) : first.slice(0, -2)
      }
    } else {
      return el.varieties[0]
    }
  }

  const filterBoardOptions = () => {
    const rankOrder = {
      A: 14,
      K: 13,
      Q: 12,
      J: 11,
      T: 10,
      "9": 9,
      "8": 8,
      "7": 7,
      "6": 6,
      "5": 5,
      "4": 4,
      "3": 3,
      "2": 2
    };

    const suitedResult = boardOptions.filter(el => el.boardSuit === boardSuit);
    const boardTypedResult = filterByBoardType(suitedResult);
    const highCardedResult = filterByHighCard(boardTypedResult);

    const result = highCardedResult.map(el => ({
      label: el.label,
      value: sliceHighLow(el)
    })).filter(option => !isUnavailableBoardVariant(option.value));

    return result.sort((a, b) => {
      const cardsA = a.label.split("");
      const cardsB = b.label.split("");

      for (let i = 0; i < 3; i++) {
        const diff = rankOrder[cardsB[i]] - rankOrder[cardsA[i]];
        if (diff !== 0) return diff;
      }

      return 0;
    });
  };

  const getRandomChallengeBoard = () => {
    const options = filterBoardOptions();
    if (options.length === 0) return '';

    return options[Math.floor(Math.random() * options.length)].value;
  };

  const finishTrainingRound = (selectedAction = '') => {
    // A queued timer from the previous hand must never grade the new hand or
    // bring its result card back after New Hand. Also settle each hand once.
    if (trainingRoundRef.current !== trainingRound || trainingRound.answered
      || !gameStarted || !combo?.combo || newHandVisible || invalidStrategy) return false;
    trainingRound.answered = true;
    const isCorrect = combo?.answer?.includes(selectedAction);
    const answerPayload = {
      correct: Boolean(isCorrect),
      game: normalizePostflopGame(tableSize, isPlo5),
      bb: stackSize,
      position_type: resultsPositionType?.value,
      position: resultsPosition?.value,
      board_type: boardType,
      hand_combo_type: selectedHandType?.value || '',
    };

    feedback.recordAnswer(isCorrect, combo);
    setIsAnswerCorrect(isCorrect);
    makeSimilarRequest(currentStep, combo?.combo || '', true)

    if (isResultsMode) {
      setGameResults((prev) => [...prev, { correct: isCorrect }]);
      challengeSession.saveAnswer(answerPayload).catch(() => {});
      prefetchNextChallengeCombo();
      setNewHandVisible(true)
      return true;
    }

    if (isTrainingMode) {
      setGameResults((prev) => [...prev, { correct: isCorrect }]);
    }

    setNewHandVisible(true)
    return true;
  }

  const handleTrainingActionClick = (action) => {
    // Practice grades the selected decision without advancing the table state.
    finishTrainingRound(action);
  }

  const handleTrainingTimeout = () => {
    finishTrainingRound('')
  }

  const handleNewHandClick = () => {
    if (!gameStarted || !newHandVisible || trainingRoundRef.current !== trainingRound) return;
    if (isResultsMode && (challengeSession.saving || challengeStopRequested)) return;
    if (isResultsMode && challengeSession.error) return;
    if (isResultsMode && !nextCombo) {
      if (!nextComboLoading) {
        prefetchNextChallengeCombo();
      }
      return;
    }

    trainingRoundRef.current = { answered: false };
    setNewHandVisible(false)
    setActionHistory((history) => (
      isResultsMode ? [] : history.filter((entry) => !entry.interactive)
    ))
    if (isResultsMode) {
      dispatch({ type: `${actionTypes.SET_SIMILAR_RESPONSE}_SUCCESS`, payload: { data: null, currentCards: [] } });
      dispatch({ type: `${actionTypes.SET_COMBO}_SUCCESS`, payload: nextCombo });
      dispatch({ type: actionTypes.SET_SEARCH_VALUE, payload: stripHandToRanks(nextCombo.combo) });
      dispatch({ type: actionTypes.CLEAR_NEXT_COMBO });
      dispatch({ type: `${actionTypes.GET_NEXT_COMBO}_RESET` });
      setTimerKey((value) => value + 1);
    } else {
      makeComboRequest();
    }
  }

  const getAnswerShortcut = (action) => getPostflopActionShortcut(
    action,
    resultAnswerActions,
    getPostflopActionContext(currentStep),
  );

  useEffect(() => {
    const handlePostflopShortcut = (event) => {
      const target = event.target;
      if (
        event.repeat
        || target?.closest?.('details, [data-game-settings], [data-trainer-feedback], [data-trainer-session-recap]')
        || event.defaultPrevented
        || !isInteractiveMode
        || target?.matches?.('input, textarea, select, [contenteditable="true"]')
        || event.ctrlKey
        || event.altKey
        || event.metaKey
      ) return;

      if (event.code === 'Space') {
        // Let focused controls keep their native Space activation (for example card colors).
        if (target?.closest?.('button, a[href], [role="button"], [role="checkbox"]')) return;
        if (newHandVisible) {
          event.preventDefault();
          handleNewHandClick();
          return;
        }

        if (!gameStarted && canStartGame) {
          event.preventDefault();
          setGameStarted(true);
        }
        return;
      }

      if (!gameStarted || newHandVisible || !combo?.combo) return;

      const action = resultAnswerActions.find((item) => (
        getAnswerShortcut(item) === event.key
      ));

      if (!action) return;
      event.preventDefault();
      handleTrainingActionClick(action);
    };

    window.addEventListener('keydown', handlePostflopShortcut);
    return () => window.removeEventListener('keydown', handlePostflopShortcut);
  });

  const getResultsPreviousActionBackground = (action) => {
    if (action === 'checkraise' || action === 'raise') {
      return getPostflopActionBackground(
        'raise',
        getPostflopActionContext(['starting']),
      );
    }
    if (action === 'donk' || action === 'cbet' || action === 'bet') {
      return getPostflopActionBackground(
        'bet',
        getPostflopActionContext(['starting']),
      );
    }
    return getPostflopActionBackground(
      'check',
      getPostflopActionContext(['starting']),
    );
  };

  const buildResultsPreviousActionButtons = () => (
    <div className={styles.resultsPreviousActionsWrapper}>
      {currentResultsPreviousActionOptions.map((option) => (
        <Button
          key={option.value}
          customBackground={
            resultsPreviousAction?.value === option.value
              ? getResultsPreviousActionBackground(option.action)
              : 'linear-gradient(180.36deg, #535353 0.31%, #272727 99.69%), #898989'
          }
          onClick={() => setResultsPreviousAction(option)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );

  const buildGameButtons = () => {
    if (!isInteractiveMode) return;
    if (!isResultsMode && (boardSituation.length === 0 || (!gameStarted && !hasPlayableTrainingStrategy))) return null;

    if (!gameStarted) {
      return (
        <div className={styles.gameButton}>
          <Button
            use="ghost"
            className={cn(styles.startStopButton, styles.startButton)}
            disabled={!canStartGame}
            onClick={() => setGameStarted(true)}
          >
            <span className={styles.startButtonContent}>
              <span>Start</span>
              <span className={styles.newHandShortcut}>SPACE</span>
            </span>
          </Button>
        </div>

      )
    }

    return (
      <div className={styles.gameButton}>
        <Button
          use="ghost"
          className={cn(styles.startStopButton, styles.stopButton)}
          disabled={isResultsMode && challengeStopRequested && challengeSession.saving}
          onClick={() => setGameStarted(false)}
        >
          {t(['stopLabel', 'Stop'])}
        </Button>
      </div>
    )
  }

  const displayedActionHistory = isResultsMode && !gameStarted
    ? []
    : actionHistory;
  const tableAmounts = getPostflopTableAmounts({
    ...getPostflopActionContext(), actionHistory: displayedActionHistory,
  });
  const betHandler = (label) => tableAmounts.contributions[label] || 0;
  const currentPot = tableAmounts.pot;
  const missingCurrentStrategy = boardSituation.length > 0
    && !roundState?.complete && !currentStrategy.previous_actions;
  const unavailableBoard = (!isResultsMode || gameStarted) && !!selectedBoard
    && (situationLoading || !!situationError || boardSituation.length === 0 || missingCurrentStrategy);
  const challengeStrategyLoading = isResultsMode && gameStarted && !!selectedBoard
    && (situationLoading || (!situationError && boardSituation.length === 0));
  const boardStatus = situationError && !String(situationError).includes('No strategy is available')
      ? 'Could not load this board. Select it again to retry.'
    : missingCurrentStrategy ? 'Strategy data is unavailable for this action. Choose another spot.'
    : 'Strategy data is unavailable for this board. Choose another board.';
  const startingBetHandler = () => '';

  const handleHighLowOptions = (e) => {
    if (!canShowHighLow || e.value === highLowOption.value) {
      return
    }

    const one = selectedBoard.at(0)
    const three = selectedBoard.at(2)
    const five = selectedBoard.at(4)
    const label = one + three + five

    const suitedResult = boardOptions.filter(el => el.boardSuit === boardSuit)
    const boardTypedResult = filterByBoardType(suitedResult)

    const target = boardTypedResult.find(item => item.label === label);
    if (target?.hasHighLow) {
      const first = target.varieties[0]
      const second = target.varieties[1]
      const firstIsHigh = first.at(-1) === 'H'
      let res = ''
      if (e.value === 'High') {
        res = firstIsHigh ? first.slice(0, -2) : second.slice(0, -2)
      } else {
        res = firstIsHigh ? second.slice(0, -2) : first.slice(0, -2)
      }
      if (isUnavailableBoardVariant(res)) return
      if (isTrainingMode) {
        resetLocalSelectionState();
        dispatch({ type: `${actionTypes.SET_COMBO}_SUCCESS`, payload: '' });
      }
      setHighLowOption(e)
      dispatch({
        type: actionTypes.SET_SELECTED_BOARD,
        payload: { value: res, preserveSelection: !isTrainingMode },
      })
      makeSituationRequest()
      if (!isTrainingMode && selectedCards.length > 0) {
        makeSimilarRequest(currentStep, selectedCards.join(''))
      }
    }
  }

  return (
    <div className={styles.trainingGame}>
      <MobileSettings maxWidth={TRAINER_SETTINGS_MAX_WIDTH}>
      <ControlPanel
        tableSizeOptions={tableSizeOptions}
        tableSize={tableSize}
        setTableSize={setTableSize}
        stackSizeOptions={availableStackSizeOptions}
        stackSize={stackSize}
        setStackSize={setStackSize}
        positionTypeOptions={availablePositionTypeOptions}
        setPositionType={setPositionType}
        positionType={positionType}
        position={position}
        positionOptions={availablePositionOptions}
        setPosition={setPosition}
        resultsPositionType={resultsPositionType}
        resultsPositionTypeOptions={availableResultsPositionTypeOptions}
        setResultsPositionType={setResultsPositionType}
        resultsPfrType={resultsPfrType}
        resultsPfrTypeOptions={currentResultsPfrTypeOptions}
        setResultsPfrType={setResultsPfrType}
        resultsPlayerPosition={resultsPlayerPosition}
        resultsPlayerPositionOptions={currentResultsPlayerPositionOptions}
        setResultsPlayerPosition={setResultsPlayerPosition}
        resultsPosition={resultsPosition}
        resultsPositionOptions={currentResultsBasePositionOptions}
        setResultsPosition={setResultsPosition}
        boardType={boardType}
        boardTypeOptions={boardTypeOptions}
        setBoardType={setBoardType}
        boardSuit={boardSuit}
        boardSuitOptions={boardSuitOptions}
        setBoardSuit={setBoardSuit}
        selectedBoard={selectedBoard}
        setSelectedBoard={setSelectedBoard}
        boardOptions={filterBoardOptions()}
        selectedHighCard={selectedHighCard}
        highCardOptions={highCardOptions}
        setSelectedHighCard={setSelectedHighCard}
        selectedHandType={selectedHandType}
        handTypeOptions={availableHandTypeOptions}
        setSelectedHandType={setSelectedHandType}
        pageMode={pageMode}
        pageModeOptions={pageModeOptions}
        setPageMode={setPageMode}
        disabled={isInteractiveMode && gameStarted}
      />
      </MobileSettings>
      <Card className={cn(styles.gameWrapper, {
        [styles.challengeGameWrapper]: isResultsMode,
        [styles.studyGameWrapper]: !isInteractiveMode,
      })}>
        {width <= TRAINER_SETTINGS_MAX_WIDTH && <SessionStatistics
          isAdaptive
          rightResults={getResultData(gameResults).right}
          wrongResults={getResultData(gameResults).wrong}
          allResults={getResultData(gameResults).all}
          onReset={() => { setGameResults([]); feedback.resetSession(); }}
        />}
        {isInteractiveMode && <TrainerFeedback {...feedback} />}
        <div className={cn(styles.pokerTableWrapper, {[styles.reducedPaddings]: height < 820})}>
          <div className={styles.pokerTable}>
            <div className={styles.potValue}>
              {selectedBoard ? `POT: ${currentPot.toFixed(1)}` : ''}
            </div>
            {
              selectedBoard && visualPositionCircles.map((el, idx) => {
                const visualSeatIndex = getVisualSeatIndex(idx, el.label);

                return (
                  <PositionCircle
                    label={el.label}
                    circleValue={circleValueHandler(el.initialCircleValue)}
                    show={el.show}
                    index={visualSeatIndex}
                    key={`${el.label || 'seat'}-${idx}`}
                    className={styles[`position${visualSeatIndex}`]}
                    isPositionActive={isPositionActive(el.show, el.label)}
                    stackSize={stackSize.split('bb')[0]}
                    bet={betHandler(el.label)}
                    chipsCollected={tableAmounts.collected}
                    startingBet={startingBetHandler(el.initialCircleValue)}
                    setCurrentActivePos={setCurrentActivePos}
                    cardColor={cardColor}
                    handleCardClick={handleCardClick}
                    isPlo5={isPlo5}
                    hideCards={el.hideCards || (isPositionActive(el.show, el.label) && (
                      (isInteractiveMode && gameStarted)
                      || (pageMode.value === 'Study'
                        && selectedCards.length === getPostflopMaxCards(isPlo5))
                    ))}
                    hu={tableSize === 'HU'}
                  />
                )
              })
            }
            <div className={cn(styles.cards, styles.p15)}>
              <div className={styles.boardCardsCluster}>
                {canShowHighLow && shouldShowHighLow() && (
                  <div className={styles.boardHighLowSlot}>
                    <button
                      type="button"
                      className={styles.highLowButton}
                      onClick={() => handleHighLowOptions(
                        highLowOption.value === 'High' ? highLowOptions[1] : highLowOptions[0]
                      )}
                      aria-label={`Show ${highLowOption.value === 'High' ? 'Low' : 'High'} board`}
                      title={`${highLowOption.value} board`}
                    >
                      <span
                        className={cn(styles.highLowChevron, {
                          [styles.highLowChevronLow]: highLowOption.value === 'Low',
                        })}
                      />
                    </button>
                  </div>
                )}
                <div className={styles.exclamationPointWrap}>
                  {
                    selectedBoard ? sortCards(selectedBoard, false, true).map((item) => (
                      <PlayingCard
                        cardMaskShow={false}
                        key={item}
                        suit={item[1]}
                        value={item[0]}
                        handleClick={handleHeroCardClick}
                        heroCard
                        heroColor={heroColor}
                      />

                    ))
                      : ''
                  }
                </div>
                {canShowHighLow && shouldShowHighLow() && (
                  <div className={styles.boardHighLowSlot} aria-hidden="true" />
                )}
              </div>
            </div>
          </div>
        </div>
        {isInteractiveMode && <SessionRecap recap={feedback.sessionRecap} onDismiss={feedback.dismissRecap} />}
        {invalidStrategy && isInteractiveMode && !challengeStrategyLoading && <p role="status">Strategy unavailable for this action. Choose another spot.</p>}
        {unavailableBoard && !situationLoading && !challengeStrategyLoading && <div className={styles.dataStatus} role="status">
          <p>{boardStatus}</p>
          {situationError && !String(situationError).includes('No strategy is available') && (
            <Button onClick={makeSituationRequest}>Retry strategy</Button>
          )}
        </div>}
        {comboError && !gameStarted && isInteractiveMode && (
          <p className={styles.dataStatus} role="alert">Could not load a training hand. Choose another spot or press Start to retry.</p>
        )}
        {nextComboError && gameStarted && isResultsMode && (
          <p className={styles.dataStatus} role="alert">The next hand could not be loaded. Press Retry to try again, or Stop to change the spot.</p>
        )}
        {challengeSession.error && (
          <div className={styles.dataStatus} role="alert">
            <p>{t(['resultsSaveError', 'Results could not be saved. Please try Stop again.'])}</p>
            {challengeStopRequested ? (
              <Button onClick={() => setGameStarted(false)} disabled={challengeSession.saving}>
                {t(['stopLabel', 'Stop'])}
              </Button>
            ) : (
              <Button onClick={() => challengeSession.retry().catch(() => {})} disabled={challengeSession.saving}>
                {t(['retrySaveLabel', 'Retry save'])}
              </Button>
            )}
          </div>
        )}
        {isInteractiveMode ? (
          <div className={cn(styles.challengeGraphSlot, {
            [styles.challengeGraphLoading]: challengeStrategyLoading,
          })} aria-busy={challengeStrategyLoading}>
            <RangeGraph
              currentStep={currentStep.join('-')}
              boardSituation={boardSituation}
              actionContext={getPostflopActionContext()}
            />
          </div>
        ) : (
          <RangeGraph
            currentStep={currentStep.join('-')}
            boardSituation={boardSituation}
            actionContext={getPostflopActionContext()}
          />
        )}
        { (selectedBoard && !unavailableBoard && pageMode.value === 'Study') ?
          <div className={styles.studyCardChooser}>
            <CardChooser
              selectedCards={selectedCards}
              setSelectedCards={setSelectedCards}
              selectedBoard={sortCards(selectedBoard, false)}
              nonSuitCardSelected={nonSuitCardSelected}
              cardColor={cardColor}
              heroColor={heroColor}
              isPlo5={isPlo5}
              clearCards={clearCards}
            />
          </div> : ''
        }
        {canShowInteractiveStage ? (
          <div className={cn(styles.trainingStepsSlot, {
            [styles.trainingStepsSlotResults]: isResultsMode,
            [styles.trainingStepsSlotActive]: gameStarted,
          })}>
            {!gameStarted && isTrainingMode ? (
              <StepsHandler
                boardSituation={boardSituation}
                currentStep={currentStep}
                setCurrentStep={handleSetCurrentStep}
                selectedCards={selectedCards}
                pageMode={pageMode.value}
                gameStarted={gameStarted}
                setGameStarted={setGameStarted}
                actionContext={getPostflopActionContext()}
              />
            ) : !gameStarted && isResultsMode ? (
              buildResultsPreviousActionButtons()
            ) : (
              <div
                className={cn(styles.trainingStepsPlaceholder, {
                  [styles.trainingStepsPlaceholderResults]: isResultsMode,
                })}
              />
            )}
          </div>
        ) : !gameStarted && !isResultsMode ? (
          <StepsHandler
            boardSituation={boardSituation}
            currentStep={currentStep}
            setCurrentStep={handleSetCurrentStep}
            selectedCards={selectedCards}
            pageMode={pageMode.value}
            gameStarted={gameStarted}
            setGameStarted={setGameStarted}
            actionContext={getPostflopActionContext()}
          />
        ) : null}
        {canShowInteractiveStage && !(isTrainingMode && !gameStarted && roundState?.complete) ? (
          <div className={cn(styles.trainingStage, {
            [styles.trainingStageResults]: isResultsMode,
            [styles.trainingStageIdle]: !gameStarted,
            [styles.trainingStageIdleWithTimer]: !gameStarted && isTrainingMode,
          })}>
            <div
              className={cn(styles.trainingHandRow, {
                [styles.trainingHandRowPlo5]: isPlo5,
              })}
            >
              <div className={styles.trainingSideSlotLeft}>
                {!gameStarted && isTrainingMode ? (
                  <Checkbox
                    name="postflop-training-timer"
                    label="Timer"
                    checked={trainingTimerEnabled}
                    onChange={(event) => setTrainingTimerEnabled(event.target.checked)}
                    className={styles.trainingTimerToggle}
                  />
                ) : canStartTrainingTimer ? (
                  <div className={styles.timerWrapper}>
                    <CountdownCircleTimer
                      isPlaying
                      duration={10}
                      colors={['#78C93F']}
                      colorsTime={[10]}
                      size={width > 2000 ? 80 : width <= 766 ? 40 : 52}
                      trailColor="#565E6C"
                      strokeWidth={width > 2000 ? 5 : 4}
                      key={timerKey}
                      onComplete={() => {
                        handleTrainingTimeout();
                      }}
                    >
                      {({ remainingTime }) => (
                        <span className={styles.timerValue}>{remainingTime}</span>
                      )}
                    </CountdownCircleTimer>
                  </div>
                ) : (
                  <div className={styles.trainingTimerPlaceholder} />
                )}
              </div>

              <div
                className={cn(styles.trainingHandSlot, {
                  [styles.trainingHandSlotPlo5]: isPlo5,
                })}
              >
                <div
                  className={cn(styles.trainingHandSurface, {
                    [styles.trainingHandSurfacePlo5]: isPlo5,
                  })}
                >
                  {gameStarted && combo?.combo ? (
                    <div key={feedback.dealId} className={cn(styles.cards, { [feedbackStyles.deal]: feedback.motionEnabled && feedback.dealAnimated })}>
                      {sortCards(combo.combo, isPlo5).map((item, index) => (
                        <PlayingCard
                          // Hidden-suit pairs can repeat (Tx, Tx); each card needs a unique key.
                          key={`${item}-${index}`}
                          suit={item[1]}
                          value={item[0]}
                          handleClick={handleHeroCardClick}
                          heroCard
                          heroColor={heroColor}
                          specialSuit={item[1] === 'x' ? true : false}
                        />
                      ))}
                    </div>
                  ) : gameStarted ? (
                    <div className={cn(styles.cards, styles.trainingCardsLoading)}>
                      {Array.from({ length: getPostflopMaxCards(isPlo5) }).map((_, index) => (
                        <div
                          key={`training-skeleton-${index}`}
                          className={styles.trainingCardSkeleton}
                        />
                      ))}
                    </div>
                  ) : (
                    <div className={styles.trainingHandPlaceholder}>
                      Press Start to begin
                    </div>
                  )}
                </div>
              </div>

              <div className={styles.trainingSideSlotRight}>
                {buildGameButtons()}
              </div>
            </div>

            {(gameStarted || isResultsMode) ? (
              <div
                className={cn(styles.cardButtonsWrapper, {
                  [styles.cardButtonsWrapperResults]: isResultsMode,
                })}
              >
                {
                  !gameStarted ? (
                    <div className={styles.trainingActionPlaceholder} />
                  ) : !newHandVisible
                  && combo?.combo
                  && (isResultsMode ? resultAnswerActions.length > 0 : boardSituation.length > 0)
                    ? resultAnswerActions.map((action) => (
                    <Button
                      key={action}
                      className={styles.trainingActionButton}
                      customBackground={getPostflopActionBackground(
                        action,
                        getPostflopActionContext(currentStep),
                      )}
                      onClick={() => {
                          handleTrainingActionClick(action)
                        }
                      }
                      >
                        <span className={styles.answerButtonContent}>
                          <span>
                            {formatPostflopAction(
                              action,
                              getPostflopActionContext(currentStep),
                            )}
                          </span>
                          {getAnswerShortcut(action) ? (
                            <span className={styles.answerShortcut}>
                              {getAnswerShortcut(action)}
                            </span>
                          ) : null}
                        </span>
                      </Button>
                  )) : newHandVisible ? <div className={styles.newRangeBtn}>
                        <div
                          key={feedback.event?.id || 0}
                          className={cn(styles.trainingResultCard, {
                            [feedbackStyles.feedbackCorrect]: feedback.motionEnabled && Boolean(feedback.event) && isAnswerCorrect,
                            [feedbackStyles.feedbackWrong]: feedback.motionEnabled && Boolean(feedback.event) && !isAnswerCorrect,
                            [styles.trainingResultCardCorrect]: isAnswerCorrect,
                            [styles.trainingResultCardWrong]: !isAnswerCorrect,
                          })}
                        >
                          <div
                            className={cn(styles.trainingResultBadge, {
                              [feedbackStyles.labelCorrect]: feedback.motionEnabled && Boolean(feedback.event) && isAnswerCorrect,
                              [feedbackStyles.labelWrong]: feedback.motionEnabled && Boolean(feedback.event) && !isAnswerCorrect,
                              [styles.trainingResultBadgeCorrect]: isAnswerCorrect,
                              [styles.trainingResultBadgeWrong]: !isAnswerCorrect,
                            })}
                          >
                            {isAnswerCorrect && <svg className={feedbackStyles.resultMark} viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="m3 8 3 3 7-7" /></svg>}{isAnswerCorrect ? 'Correct' : 'Wrong'}
                          </div>
                          {correctAnswerLabels.length > 0 && (
                            <div className={styles.trainingResultCaption} data-testid="correct-answer">
                              Correct is: <strong>{correctAnswerLabels.join(' / ')}</strong>
                            </div>
                          )}
                          <Button
                            use="ghost"
                            className={styles.newHandButton}
                            disabled={isResultsMode && (challengeSession.saving
                              || Boolean(challengeSession.error) || challengeStopRequested || nextComboLoading)}
                            onClick={() => handleNewHandClick()}
                          >
                            <span className={styles.newHandButtonContent}>
                              <span className={styles.newHandButtonLabel}>
                                {nextComboError && !nextCombo ? 'Retry' : 'New Hand'}
                              </span>
                              <span className={styles.newHandShortcut}>SPACE</span>
                            </span>
                          </Button>
                        </div>
                      </div> : <div className={styles.trainingActionPlaceholder} />
                }
              </div>
            ) : null}
          </div>
        ) : ''}
      </Card>
      <ResultPanel
        strategyUnavailable={!challengeStrategyLoading && (invalidStrategy || unavailableBoard)}
        statusMessage={!situationLoading ? (unavailableBoard ? boardStatus : 'Strategy unavailable for this action. Choose another spot.') : ''}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        syncCardsFromSearch={syncCardsFromSearch}
        resultCategory={resultCategory}
        setResultCategory={setResultCategory}
        makeSimilarRequest={makeSimilarRequest}
        selectedBoard={selectedBoard}
        selectedCards={selectedCards}
        currentStep={currentStep}
        setNonSuitCardSelected={setNonSuitCardSelected}
        clearCards={clearCards}
        isPlo5={isPlo5}
        pageMode={pageMode}
        rightResults={getResultData(gameResults).right}
        wrongResults={getResultData(gameResults).wrong}
        allResults={getResultData(gameResults).all}
        resetTrainingResults={() => { setGameResults([]); feedback.resetSession(); }}
        actionContext={getPostflopActionContext()}
      />
    </div>
  )
};

export default Postflop;
